import React, { useState, useEffect } from "react";
import axios from "axios";
import ScoreboardElement from "./ScoreboardElement";

export default function Scoreboard({ options }) {
  const [highscores, setHighscores] = useState([]);

  function getHighscores() {
    axios
      .get("https://tyverihighscore.herokuapp.com/highscores")
      .then((value) => {
        const data = value.data;
        const length = data.length;
        setHighscores(data.slice(0, Math.min(length, 20)));
      });
  }

  useEffect(() => {
    getHighscores();
    let interval = setInterval(getHighscores, 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  console.log(highscores);

  let rank = 0;

  return (
    <div className="itemlist">
      <table>
        <thead>
          <tr>
            <th>Rank#</th>
            <th>Player</th>
            <th>Score</th>
            <th>Size</th>
            <th>Difficulty</th>
          </tr>
        </thead>
        <tbody>
          {highscores.map((value, index) => {
            if (matchesOptions(value, options)) {
              rank++;
              return (
                <ScoreboardElement
                  rank={rank}
                  highscore={value}
                  key={index + 1}
                  className={"item"}
                />
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
}

function matchesOptions(value, options) {
  const { mapsize, difficulty } = options;

  return (
    (value.mapsize == mapsize.toLowerCase() || mapsize == "Both") &&
    (value.difficulty == difficulty.toLowerCase() || difficulty == "Any")
  );
}
